// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_main_goals {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.goals_widget_add_wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    opacity: 0.7;
}

.goals_widget_add_wrapper:hover {
    opacity: 1;
}

.goals_widget_add_icon {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 12.5px;
    background-position: center;
    background-repeat: no-repeat;
}

.goals_widget_add_text {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
    white-space: nowrap;
}

.goals_widget_content {
    flex: 1;
    overflow-y: auto;
    padding: 12px 0;
    min-height: 0;
}

.goals_widget_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding-right: 4px;
}

.goals_widget_empty,
.goals_widget_loading {
    text-align: center;
    color: #86868B;
    font-size: calc(14px * var(--fontScaler));
    font-weight: 400;
    padding: 40px 20px;
}

.goals_widget_error {
    text-align: center;
    color: #FF3B30;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    padding: 12px 16px;
    background-color: #FFF5F5;
    border-radius: 8px;
    margin-bottom: 12px;
    border: 0.5px solid rgba(255, 59, 48, 0.2);
}

/* Scrollbar styling */
.goals_widget_content::-webkit-scrollbar {
    width: 8px;
}

.goals_widget_content::-webkit-scrollbar-track {
    background: transparent;
}

.goals_widget_content::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    border: 2px solid #FFFFFF;
}

.goals_widget_content::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/goalsWidget/GoalsWidget.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAmD;IACnD,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".dashboard_main_goals {\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.goals_widget_add_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    opacity: 0.7;\n}\n\n.goals_widget_add_wrapper:hover {\n    opacity: 1;\n}\n\n.goals_widget_add_icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/add.svg');\n    background-size: 12.5px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.goals_widget_add_text {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n    white-space: nowrap;\n}\n\n.goals_widget_content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 12px 0;\n    min-height: 0;\n}\n\n.goals_widget_grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n    padding-right: 4px;\n}\n\n.goals_widget_empty,\n.goals_widget_loading {\n    text-align: center;\n    color: #86868B;\n    font-size: calc(14px * var(--fontScaler));\n    font-weight: 400;\n    padding: 40px 20px;\n}\n\n.goals_widget_error {\n    text-align: center;\n    color: #FF3B30;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    padding: 12px 16px;\n    background-color: #FFF5F5;\n    border-radius: 8px;\n    margin-bottom: 12px;\n    border: 0.5px solid rgba(255, 59, 48, 0.2);\n}\n\n/* Scrollbar styling */\n.goals_widget_content::-webkit-scrollbar {\n    width: 8px;\n}\n\n.goals_widget_content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.goals_widget_content::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n    border: 2px solid #FFFFFF;\n}\n\n.goals_widget_content::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
